<template>
  <!-- fastreport -->
  <div class="zwx-fastreport" v-show="false">
    <zwx-ipc ref="wsRptRef" @message="wsRpt" @connect="connect"></zwx-ipc>
  </div>
</template>

<script>
export default {
  name: 'ZwxFastreport',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    // socket连接状态
    connect(connect) {
      this.$emit('connect', connect)
    },
    // fastreport
    wsRpt(message) {
      if (message.state != '1') return
      // 0 设计
      if (message.operate == '0') {
        // 设计并保存
        if (message.savereport == '1' && message.uploadUrl !== undefined && message.uploadUrl !== null && message.uploadUrl.trim().length > 0) {
          this.$emit('callback', '0', message.reportName, message.uploadUrl)
          return
        }
        return
      }
      // 1 预览
      if (message.operate == '1') {
        // 1 预览 中 打印
        if (message.printed !== undefined && message.printed !== null && message.printed > 0) {
          this.$emit('callback', '4', message.reportName)
          return
        }
        this.$emit('callback', '1', message.reportName)
        return
      }
      // 2 打印 中 打印
      if (message.operate == '2') {
        // 打印数量大于0
        if (message.printed !== undefined && message.printed !== null && message.printed > 0) {
          this.$emit('callback', '2', message.reportName)
          return
        }
        return
      }
      // 3 导出PDF
      if (message.operate == '3') {
        this.$emit('callback', '3', message.reportName, message.uploadUrl, message.rid)
        return
      }
    },
    // 00 初次设计
    // { apuType: 'RPT', operate: '0', reportName: '1002', rptDatas: [], RptDataRefs: [] }
    rpt00(reportName, rptDatas, rptDataRefs) {
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '0', reportName: reportName, rptDatas: rptDatas, RptDataRefs: rptDataRefs })
    },
    // 01 再次设计
    // { apuType: 'RPT', operate: '0', reportName: '1002', rptUrl: 'https://10.88.99.242:9003/file/npe/fr3/2023-02-18/3E4ACF06DBC3410F80723569DB4831E2.fr3', version: '2', rptDatas: [], RptDataRefs: [] }
    rpt01(reportName, rptUrl, version, rptDatas, rptDataRefs) {
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '0', reportName: reportName, rptUrl: rptUrl, version: version, rptDatas: rptDatas, RptDataRefs: rptDataRefs })
    },
    // 1 预览
    // { apuType: 'RPT', operate: '1', reportName: '1002', rptUrl: 'https://10.88.99.242:9003/file/npe/fr3/2023-02-18/3E4ACF06DBC3410F80723569DB4831E2.fr3', version: '2', rptDatas: [], RptDataRefs: [] }
    rpt1(reportName, rptUrl, version, rptDatas, rptDataRefs) {
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '1', reportName: reportName, rptUrl: rptUrl, version: version, rptDatas: rptDatas, RptDataRefs: rptDataRefs })
    },
    // 2 打印
    // { apuType: 'RPT', operate: '2', reportName: '1002', printerName: 'Microsoft Print to PDF', copies: '1', rptUrl: 'https://10.88.99.242:9003/file/npe/fr3/2023-02-18/3E4ACF06DBC3410F80723569DB4831E2.fr3', version: '2', rptDatas: [], RptDataRefs: [] }
    rpt2(reportName, printerName, copies, rptUrl, version, rptDatas, rptDataRefs) {
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '2', reportName: reportName, printerName: printerName, copies: copies, rptUrl: rptUrl, version: version, rptDatas: rptDatas, RptDataRefs: rptDataRefs })
    },
    // 30 导出PDF，不上传到服务器
    // { apuType: 'RPT', operate: '3', reportName: '1002', exportPath: 'C:\\中卫信设备通信服务\\updateFile\\abc.pdf', uploadUrl: '0', rptUrl: 'https://10.88.99.242:9003/file/npe/fr3/2023-02-18/3E4ACF06DBC3410F80723569DB4831E2.fr3', version: '2', rptDatas: [], RptDataRefs: [] }
    rpt30(reportName, exportPath, rptUrl, version, rptDatas, rptDataRefs, rid) {
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '3', reportName: reportName, exportPath: exportPath, uploadUrl: '0', rptUrl: rptUrl, version: version, rptDatas: rptDatas, RptDataRefs: rptDataRefs, rid })
    },
    // 31 导出PDF，上传到服务器
    // { apuType: 'RPT', operate: '3', reportName: '1002', exportPath: 'C:\\中卫信设备通信服务\\updateFile\\abc.pdf', uploadUrl: '1', rptUrl: 'https://10.88.99.242:9003/file/npe/fr3/2023-02-18/3E4ACF06DBC3410F80723569DB4831E2.fr3', version: '2', rptDatas: [], RptDataRefs: [] }
    rpt31(reportName, exportPath, rptUrl, version, rptDatas, rptDataRefs, rid) {
      // 上传到服务器
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '3', reportName: reportName, exportPath: exportPath, uploadUrl: '1', rptUrl: rptUrl, version: version, rptDatas: rptDatas, RptDataRefs: rptDataRefs, rid })
    },
    // 32 导出word，不上传到服务器
    // { apuType: 'RPT', operate: '3', reportName: '1002', exportPath: 'C:\\中卫信设备通信服务\\updateFile\\abc.pdf', uploadUrl: '1', rptUrl: 'https://10.88.99.242:9003/file/npe/fr3/2023-02-18/3E4ACF06DBC3410F80723569DB4831E2.fr3', version: '2', rptDatas: [], RptDataRefs: [] }
    rpt32(reportName, exportPath, rptUrl, version, rptDatas, rptDataRefs, rid) {
      // 上传到服务器
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '5', reportName: reportName, exportPath: exportPath, uploadUrl: '0', rptUrl: rptUrl, version: version, rptDatas: rptDatas, RptDataRefs: rptDataRefs })
    },

    // 33 导出word，上传到服务器
    // { apuType: 'RPT', operate: '3', reportName: '1002', exportPath: 'C:\\中卫信设备通信服务\\updateFile\\abc.pdf', uploadUrl: '1', rptUrl: 'https://10.88.99.242:9003/file/npe/fr3/2023-02-18/3E4ACF06DBC3410F80723569DB4831E2.fr3', version: '2', rptDatas: [], RptDataRefs: [] }
    rpt33(reportName, exportPath, rptUrl, version, rptDatas, rptDataRefs, rid) {
      // 上传到服务器
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].send({ apuType: 'RPT', operate: '5', reportName: reportName, exportPath: exportPath, uploadUrl: '1', rptUrl: rptUrl, version: version, rptDatas: rptDatas, RptDataRefs: rptDataRefs, rid })
    },

    // 检查中卫信设备通信服务运行状态
    check() {
      this.$refs['wsRptRef'] && this.$refs['wsRptRef'].check()
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
